import { Pipe, PipeTransform } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
@Pipe({
    name: 'Filename',
    standalone: false
})

export class FilenamePipe implements PipeTransform {
  public isMobile: boolean;
  constructor(
    private readonly deviceService: DeviceDetectorService
  ) {
    this.isMobile = this.deviceService.isMobile();
  }

   transform(value: string): string {

    if (this.isMobile && value && value.length > 20) {
      return value.substring(0, 20) + '...';
    } else if(value && value.length > 32) {
      return value.substring(0, 32) + '...';
    }

    return value;
  }
}
